

<template>
  <view wx:style="padding-left: 40px; height: 60px;margin-top:20px;"
    ><input
      wx:style="height: 60px;"
      type="file"
      @change="upload"
      accept="image/jpg,image/jpeg,image/png"
    />
  </view>
  <view><cover-image src="{{imgSrc}}"></cover-image></view>
</template>

<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'

  createPage({
    data: {
      imgSrc: ''
    },
    methods: {
      upload(e) {
        const that = this
        console.log(e.target.files, 'files文件')
        const reader = new FileReader()
        reader.readAsDataURL(e.target.files[0])
        reader.onload = function(e) {
          // 读取到的图片 base64 数据编码 将此编码字符串传给后台即可
          that.imgSrc = e.target.result
          console.log(that.imgSrc, 'imgBase64')
        }
      }
    },
    beforeCreate() {},
    created() {}
  })
</script>

